<div class="catalog-container">
  <div class="career-title">
    {{careerPageData?.pageTitle}}<app-skeleton *ngIf="!careerPageData" [type]="'text'" [symbolsCount]="14"/>
  </div>


  <app-search-field
    (searchQueryChange)="onSearchInputChange($event)"
    (onSubmit)="onSearchInputSubmit($event)"
    (openCloseMobilePopup)="changeSidebarMenu($event)"
    [placeholder]="careerPageData.searchPlaceHolder"
    [autocompleteNoResultsText]="careerPageData.searchAutocompleteNoResultsText"
    [isMobile]="isMobile"
    [apiEndpointUrl]="'/Portal/Career-Api/GetPortalAutocomplete'"
    [mainCatalogId]="this.careerPageData.nodeId"
    [useCustomSubmitHandler]="true"
    *ngIf="careerPageData"
  ></app-search-field>
  <div *ngIf="!careerPageData" class="search-bar-skeleton">
    <app-skeleton/>
  </div>

  <div class="catalog-wrapper">
    <div class="search-catalog">
      <div class="search-catalog__filters" [ngClass]="{'hide-mobile': isMobile}">
        <div class="search-catalog__filters-header">
          <div class="search-catalog__filters-header__text">
            {{careerPageData?.filtersSectionTitle}}<app-skeleton [type]="'text'" *ngIf="!careerPageData" [symbolsCount]="6"/>
          </div>
          <a *ngIf="careerPageData" class="search-catalog__filters-header__clear-btn link" (click)="clearFilters($event)">
            {{careerPageData.resetFiltersButtonText}}
          </a>
          <app-skeleton *ngIf="!careerPageData" [type]="'text'" [symbolsCount]="10"/>
        </div>
        <ng-container *ngIf="careerPageData">
          <app-expansion-panel
            *ngFor="let filterGroup of careerPageData.filters"
            [title]="filterGroup.filterGroupTitle"
            [filters]="filterGroup.filters"
            [isExpanded]="false"
            [selectedFilters]="filters"
            (filterStatusChanged)="
              onFilterStatusChange($event.event.checked, $event.filter)
            "
            [isKeyString]="true"
          ></app-expansion-panel>
        </ng-container>

        <ng-container *ngIf="!careerPageData">
          <div class="skeleton-filter-group" *ngFor="let _ of [].constructor(4)">
            <app-skeleton [type]="'text'" [symbolsCount]="8"/>
          </div>
        </ng-container>
      </div>


      <div class="search-catalog__filters-popup" *ngIf="careerPageData" [ngClass]="{'hide-mobile': !isMobile}">
        <div class="slide-up-header" (click)="openFiltersMobilePopup()">
          <div class="filter-icon">
            <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
          </div>
          <div class="filter-text">{{careerPageData.filtersSectionTitle}}</div>
        </div>
        <div class="catalog-filters-mobile" *ngIf="showFiltersMobileModal">
          <div class="catalog-filters-mobile__content">
            <span class="close" (click)="closeFiltersMobilePopup()">
              &times;
            </span>
            <div class="slide-up-header">
              <div class="filter-icon">
                <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
              </div>
              <div class="filter-text">{{careerPageData.filtersSectionTitle}}</div>
            </div>
            <div class="slide-up-filters-content">
              <app-expansion-panel
                *ngFor="let filterGroup of careerPageData.filters"
                [title]="filterGroup.filterGroupTitle"
                [filters]="filterGroup.filters"
                [isExpanded]="false"
                [selectedFilters]="filters"
                (filterStatusChanged)="onFilterStatusChange($event.event.checked, $event.filter)"
                [isKeyString]="true"
              ></app-expansion-panel>
            </div>
            <div class="slide-up-filters-bottom">
              <div class="slide-up-filters-bottom__text">
                {{careerPageData.totalSearchResultCounterFormat}} {{this.careerPageData.searchResults.totalSearchResultsCount}}
              </div>
              <button class="slide-up-filters-bottom__clear-btn link" (click)="clearFilters($event)" [disabled]="getFiltersEnableStatus()">
                {{careerPageData.mobileFiltersClearBtnText}}
              </button>
              <button class="slide-up-filters-bottom__search-submit" (click)="closeFiltersMobilePopup()">
                {{careerPageData.mobileFiltersShowBtnText}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="search-catalog__filters-popup" *ngIf="!careerPageData" [ngClass]="{'hide-mobile': !isMobile}">
        <div class="slide-up-header">
          <app-skeleton [height]="36" [width]="120"/>
        </div>
      </div>

      <div class="search-catalog__result">
        <app-career-lobby-positions-list
          [resultText]="careerPageData?.totalSearchResultCounterFormat"
          [noResultsTitle]="careerPageData?.noResultsTitle"
          [noResultsText]="careerPageData?.noResultsText"
          [noResultsImage]="careerPageData?.noResultsImageUrl"
          [clearAllText]="careerPageData?.noResultsClearAllBtnText"
          [pageSize]="careerPageData?.pageSize"
          [sortingByDateOptionTitle]="careerPageData?.sortingByDateOptionTitle ?? ''"
          [sortingByTitleOptionTitle]="careerPageData?.sortingByTitleOptionTitle ?? ''"
          [sortingByTypeOptionTitle]="careerPageData?.sortingByTypeOptionTitle ?? ''"
          [sortingDropdownPlaceholder]="careerPageData?.sortingDropdownPlaceholder ?? ''"
          [cards]="careerPageData?.searchResults?.cards"
          [totalSearchResultsCount]="careerPageData?.searchResults?.totalSearchResultsCount"
          [currentPage]="currentPage"
          [sorting]="sorting"
          [isLoading]="isLoading"
          [isPageLoading]="!careerPageData"
          [cardLayoutData]="careerPageData"
          (pageChange)="onPageChange($event)"
          (clearAllBtnClick)="clearAllParams()"
          (sortingChange)="onSortingChange($event)"
        ></app-career-lobby-positions-list>
      </div>
    </div>
  </div>
</div>
